import { Container, Divider } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  ArrayTagChip,
  CustomTable,
  ModalError,
  MultipleSelectInput,
  MultipleSelectInputWithTags,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  SongUsageTrendChart,
  YearPicker,
} from "components";
import { monthData } from "constants";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { isEqual } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  arrayToCommaSeparatedString,
  createAllFilterOption,
  downloadFileFromRes,
  getErrors,
  handleChangeFilterAll,
} from "utils";
import ModalRevenueInformation from "../../Pencipta/PaymentPencipta/Components/ModalRevenueInformation";
import {
  columnTableDashboard,
  columnTableInvoice,
} from "./components/ConstantDashboardComposer";
import InformationCard from "./components/InformationCard";
import ModalDashboardDetail from "./components/ModaDashboardlDetail";

const DashboardPencipta = () => {
  const classes = globalStyles();
  const history = useHistory();
  const isFirstLoad = useRef(true);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [userName, setUserName] = useState(
    localStorage?.getItem("userName") || ""
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [optionDsp, setOptionDsp] = useState([]);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [queryParams, setQueryParams] = useState({
    year: localStorage.getItem("year") || moment().year(),
    dsp_ids: "",
    months: getFromLocalStorage("months", 0),
  });
  const [dashboardSummary, setDashboardSummary] = useState({
    balance_number: 0,
    paid_amount: 0,
  });
  const [dashboardInformation, setDashboardInformation] = useState({
    songs: 0,
    traffic: 0,
    revenue: 0,
  });
  const [dataTableDashboard, setDataTableDashboard] = useState([]);
  const [detailComposer, setDetailComposer] = useState({});
  const [tableParamsDashboard, setTableParamsDashboard] = useState({
    page: getFromLocalStorage("dashboard_page", 1),
    size: getFromLocalStorage("dashboard_size", 10),
    sort: localStorage.getItem("dashboard_sort") || "",
  });
  const [tableTotalPageDashboard, setTableTotalPageDashboard] = useState(1);
  const [dataTableInvoice, setDataTableInvoice] = useState([]);
  const [tableParamsInvoice, setTableParamsInvoice] = useState({
    page: getFromLocalStorage("invoice_page", 1),
    size: getFromLocalStorage("invoice_size", 10),
  });
  const [tableTotalPageInvoice, setTableTotalPageInvoice] = useState(1);
  const [selectedDSP, setSelectedDSP] = useState([]);
  const [selectedMonthFilter, setSelectedMonthFilter] = useState([]);
  const prevQueryParams = usePrevious(queryParams);
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      [key]: value,
    }));
    localStorage.setItem(key, value);
  };
  const handleChangeTableParamsDashboard = (value, key) => {
    setTableParamsDashboard(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    localStorage.setItem(`dashboard_${key}`, value);
    if (key !== "page") {
      localStorage.setItem("dashboard_page", 1);
    }
  };
  const handleChangeTableParamsInvoice = (value, key) => {
    setTableParamsInvoice(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    localStorage.setItem(`invoice_${key}`, value);
    if (key !== "page") {
      localStorage.setItem("invoice_page", 1);
    }
  };
  const handleChangeFilterDSP = (event, option) => {
    const { checked } = event?.target || false;
    setSelectedDSP(
      handleChangeFilterAll({
        selectedList: selectedDSP,
        checked,
        option,
        key: "dsp_id",
        list: optionDsp,
        handleChangeQueryParams,
        paramsKey: "dsp_ids",
      })
    );
  };
  const handleChangeFilterMonth = (event, option) => {
    const { checked } = event?.target || false;
    setSelectedMonthFilter(prev => {
      const newSelectedMonthFilter = checked
        ? [...prev, option]
        : prev.filter(month => month.id !== option.id);
      handleChangeQueryParams(
        newSelectedMonthFilter.map(month => month.id).join(","),
        "months"
      );
      return newSelectedMonthFilter;
    });
  };
  const getUserDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/me`, {
        headers,
      });
      const { data } = res?.data;
      setUserName(data?.name);
      localStorage.setItem("userName", data?.name);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getOptionDsp = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/dashboard/option?dsp_flag=ACTIVE`,
        { headers }
      );
      const modifiedData = [
        createAllFilterOption({ label: "name", key: "dsp_id" }),
        ...res?.data?.data?.dsp,
      ];
      setOptionDsp(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDashboardSummary = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/composer/transaction/payment/get-balance`,
        { headers }
      );
      setDashboardSummary(res?.data?.data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTableDashboard = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/composer/dashboard/v2/song-usage/table`,
        {
          headers,
          params: {
            ...tableParamsDashboard,
            ...queryParams,
          },
        }
      );
      const { data, meta } = res?.data;
      setDataTableDashboard(data?.data || []);
      const pageCount = getTotalPage(meta?.total, tableParamsDashboard?.size);
      setTableTotalPageDashboard(pageCount || 1);
      setDashboardInformation(prev => ({
        ...prev,
        songs: meta?.total,
      }));
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const getDataTableInvoice = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/composer/transaction/v2/payment-claim`,
        { headers, params: tableParamsInvoice }
      );
      const { data, meta } = res?.data;
      setDataTableInvoice(data || []);
      const pageCount = getTotalPage(meta?.total, tableParamsInvoice?.size);
      setTableTotalPageInvoice(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const getChartData = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/composer/dashboard/v2/chart`,
        {
          headers,
          params: {
            ...queryParams,
          },
        }
      );
      const { data } = res?.data || [];

      if (queryParams?.dsp_ids?.length === 0) {
        const defaultDSP = data?.charts?.map(item => ({
          dsp_id: item?.dsp_id,
          name: item?.dsp_name,
          color: item?.color,
        }));
        setSelectedDSP(defaultDSP);
        const paramsDSP = arrayToCommaSeparatedString(defaultDSP, "dsp_id");
        handleChangeQueryParams(paramsDSP, "dsp_ids");
      } else {
        if (data?.charts?.length > 0) {
          const labels = data?.charts?.[0]?.items?.map(item =>
            moment(item.date).format("MMM YY")
          );
          const datasets = data?.charts?.map(item => ({
            label: item?.dsp_name,
            data: item?.items?.map(chartItem => chartItem?.revenue),
            listener: item?.items?.map(chartItem => chartItem?.total_stream),
            color: item?.color,
            showMark: false,
          }));
          setChartData({
            labels,
            datasets,
          });
          setDashboardInformation(prev => ({
            ...prev,
            traffic: data?.total_stream,
            revenue: data?.total_revenue,
          }));
        } else {
          setChartData({
            labels: [],
            datasets: [],
          });
          setDashboardInformation(prev => ({
            ...prev,
            traffic: 0,
            revenue: 0,
          }));
        }
      }
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const handleDownloadXLSX = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/composer/dashboard/v2/export`,
        {
          headers,
          params: queryParams,
          responseType: "blob",
        }
      );
      downloadFileFromRes(res);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [];
    if (!userName) promises.push(getUserDetail());
    promises.push(getDashboardSummary());
    promises.push(getDataTableInvoice());
    promises.push(getChartData());
    promises.push(getDataTableDashboard());

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
      isFirstLoad.current = false;
    }
  };

  useEffect(() => {
    getOptionDsp();
    fetchData();
  }, [queryParams?.dsp_ids]);

  useEffect(() => {
    if (!isFirstLoad.current) {
      if (prevQueryParams && !isEqual(prevQueryParams, queryParams)) {
        if (tableParamsDashboard?.page !== 1) {
          handleChangeTableParamsDashboard(1, "page");
        }
        getChartData();
      }
      getDataTableDashboard();
    }
  }, [queryParams, tableParamsDashboard]);
  useEffect(() => {
    if (!isFirstLoad.current) {
      getDataTableInvoice();
    }
  }, [tableParamsInvoice]);
  const showModalDetail = Boolean(detailComposer?.song_id);

  return (
    <Page
      className={classes.root}
      title="Dashboard"
      data-testid="data-test-page-dashboard"
    >
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={`Dashboard ${userName ? ` | ${userName}` : ""}`}
            breadcrumbData={breadcrumbData}
          />
          <Divider className={classes.divider} />
          <Grid container>
            <InformationCard
              title="Total Balance"
              value={dashboardSummary?.balance_number}
              buttonLabel="View Revenue Information"
              onClick={() => setModalVisible(true)}
              prefix="Rp"
              length={2}
            />
            <InformationCard
              title="Paid Amount"
              value={dashboardSummary?.paid_amount}
              prefix="Rp"
              onClick={() => history.push("/pencipta/payment")}
              length={2}
            />
          </Grid>
          <Grid container justifyContent="right" spacing={1} my="16px">
            <Grid item>
              <MultipleSelectInputWithTags
                value={selectedDSP}
                textValue="DSP"
                options={optionDsp}
                optionKey="dsp_id"
                optionLabel="name"
                onChange={handleChangeFilterDSP}
              />
            </Grid>
            <Grid item>
              <MultipleSelectInput
                placeholder="All Month"
                value={selectedMonthFilter}
                textValue={arrayToCommaSeparatedString(
                  selectedMonthFilter,
                  "shortName"
                )}
                options={monthData}
                optionKey="id"
                optionLabel="fullName"
                onChange={handleChangeFilterMonth}
                width={255}
              />
            </Grid>
            <Grid item>
              <YearPicker
                label="Year"
                value={queryParams?.year}
                onChange={date => handleChangeQueryParams(date, "year")}
                width={150}
              />
            </Grid>
          </Grid>
          <Box
            border="1px solid #ebebeb"
            borderRadius="5px"
            padding="50px 20px"
            my="24px"
          >
            {chartData?.datasets.length > 0 && queryParams?.dsp_ids && (
              <ArrayTagChip
                selectionsList={
                  selectedDSP.some(item => item.dsp_id === "all")
                    ? [{ dsp_id: "all", name: "All" }]
                    : selectedDSP
                }
                value="name"
              />
            )}
            <Box width="100%" mt={2}>
              <SongUsageTrendChart chartData={chartData} />
            </Box>
          </Box>
          <Grid container my="16px">
            <InformationCard
              title="Total Songs"
              value={dashboardInformation?.songs}
              length={3}
            />
            <InformationCard
              title="Total Listener Traffic"
              value={dashboardInformation?.traffic}
              length={3}
            />
            <InformationCard
              title="Total Revenue"
              value={dashboardInformation?.revenue}
              prefix="Rp"
              length={3}
            />
          </Grid>
          <Grid container justifyContent="right" columnSpacing={1} my={2}>
            <Grid item>
              <PrimaryButton
                label="Download PDF"
                onClick={() =>
                  history.push({
                    pathname: "/pencipta/dashboard-pencipta/print-report",
                    state: {
                      dashboardSummary,
                      chartData,
                      queryParams,
                      selectedDSP,
                      userName,
                      dashboardInformation,
                      dataTableDashboard,
                      dataTableInvoice,
                    },
                  })
                }
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Download XLSX"
                onClick={handleDownloadXLSX}
              />
            </Grid>
          </Grid>
          <CustomTable
            columnTable={columnTableDashboard()}
            data={dataTableDashboard}
            page={tableParamsDashboard?.page}
            pageSize={tableParamsDashboard?.size}
            pageCount={tableTotalPageDashboard}
            handleChangePage={(_, page) =>
              handleChangeTableParamsDashboard(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeTableParamsDashboard(e?.target?.value, "size")
            }
            sortValue={tableParamsDashboard?.sort}
            onRequestSort={sortBy => {
              handleChangeTableParamsDashboard(
                `${sortBy} ${
                  tableParamsDashboard.sort === `${sortBy} asc` ? "desc" : "asc"
                }`,
                "sort"
              );
            }}
            isHaveAction
            renderAction={item => (
              <PrimaryButton
                label="See Details"
                onClick={() =>
                  setDetailComposer({
                    song_id: item?.song_id,
                    year: queryParams?.year,
                    month: queryParams?.months,
                    dsp_ids: queryParams?.dsp_ids,
                    name: item?.title,
                  })
                }
                width={140}
              />
            )}
          />
          <SectionLabel title="Payment Claim" my="16px" />
          <CustomTable
            columnTable={columnTableInvoice()}
            data={dataTableInvoice}
            page={tableParamsInvoice?.page}
            pageSize={tableParamsInvoice?.size}
            pageCount={tableTotalPageInvoice}
            handleChangePage={(_, page) =>
              handleChangeTableParamsInvoice(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeTableParamsInvoice(e?.target?.value, "size")
            }
            isHaveAction
            handleView={item =>
              history.push(`/pencipta/payment/${item?.invoice_id}`)
            }
          />
        </Container>
      )}
      {modalVisible && (
        <ModalRevenueInformation
          open={modalVisible}
          onClose={() => setModalVisible(false)}
        />
      )}
      {showModalDetail && (
        <ModalDashboardDetail
          open={showModalDetail}
          onClose={() => setDetailComposer({})}
          params={detailComposer}
        />
      )}
    </Page>
  );
};

const getFromLocalStorage = (key, defaultValue) => {
  const value = localStorage.getItem(key);
  return value ? Number(value) : defaultValue;
};
const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
const breadcrumbData = [
  {
    label: "Home",
    link: "/pencipta/dashboard-pencipta",
  },
  {
    label: "Dashboard",
    active: true,
  },
];

export default DashboardPencipta;
